import { Box, styled } from '@mui/material';

export const TopNavWrapperStyled = styled(Box)({
  display: 'grid',
  // Start with 4 columns for larger screens
  gridTemplateColumns: 'repeat(4, 1fr)',
  flexWrap: 'wrap',
  columnGap: '1.6rem',
  rowGap: '16px',
  '@media (max-width: 743px)': {
    marginTop: '12px',
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
});

export const NavButtonStyled = styled('button')({
  backgroundColor: 'var(--neutral-white, #FFFFFF)',
  height: '56px',
  width: '100%',
  display: 'flex',
  padding: '0 5px 0 13px',
  alignItems: 'center',
  borderRadius: '4px 4px 4px 4px',
  border: '1px solid var(--neutral-grey-200, #E6E6E6)',
  '@media (min-width: 744px)': {
    height: '64px',
    maxWidth: '248px',
    backgroundColor: 'var(--branding-primary-900, #212935)',
    color: 'var(--neutral-white, #FFFFFF)',
    borderRadius: '0px 0px 4px 4px',
    border: 'none',
  },
  '@media (min-width: 1200px)': {
    maxWidth: '248px',
    padding: '0 20px 0 24px',
  },
});

export const NavTextStyled = styled('p')({
  whiteSpace: 'initial',
  textAlign: 'left',
  marginBottom: 0,
  '@media (max-width: 1199px)': {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  '@media (min-width: 1200px)': {
    fontSize: '19px',
    fontWeight: 600,
    lineHeight: '26.6px',
    letterSpacing: '0.15px',
  },
  '@media (min-width: 744px)': {
    color: 'var(--neutral-white, #FFFFFF)',
  },
});

export const IconStyled = styled('div')({
  marginRight: '12px',
  '@media (max-width: 1199px)': {
    width: '24px'
  },
  '@media (min-width: 1200px)': {
    width: '32px'
  },
});

export const MobileShow = styled('div')({
  '@media (min-width: 744px)': {
    ariaHidden: 'true',
    display: 'none',
    visibility: 'hidden',
  },
});
